import { render } from "./company-settings.vue?vue&type=template&id=4f54366e"
import script from "./company-settings.vue?vue&type=script&lang=js"
export * from "./company-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__